import { ref } from "@vue/reactivity";

export const usePage = (handleSearch) => {
    let total = ref(0);
    let currentPage = ref(1);
    let pageSize = ref(15);

    const handleSizeChange = (val) => {
        currentPage.value = 1;
        pageSize.value = val;
        handleSearch && handleSearch();
    };
    const handleCurrentChange = (val) => {
        currentPage.value = val;
        handleSearch && handleSearch();
    };
    return {
        total,
        currentPage,
        pageSize,
        handleSizeChange,
        handleCurrentChange,
    };
};
